import React from 'react'
import { Desc, Head2 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'

export const FastestShot: React.FC = () => {
  return (
    <>
      <Head2 textColor={colors.gray.gray20}>{`Rounds`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 1: Five athletes`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 2: Two athletes`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`The finalist with the slowest speed from the first round one will go first, the finalist with the fastest speed from the first round will go second`}</Desc>
        </li>
      </ul>
      <Head2 textColor={colors.gray.gray20}>{`Former Winners`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Jarrod Neumann`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Jarrod Neumann`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Jarrod Neumann`}</Desc>
        </li>
      </ul>
    </>
  )
}
